import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "role-detail" }
const _hoisted_2 = { class: "role-detail-main" }
const _hoisted_3 = { class: "check-permission" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_has = _resolveDirective("has")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_page_header, {
      onBack: _ctx.goBack,
      title: "返回上一级",
      content: "详情页面"
    }, null, 8 /* PROPS */, ["onBack"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        ref: "form",
        model: _ctx.roleModel,
        "status-icon": "",
        rules: _ctx.rules,
        "label-width": "100px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "角色名",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                maxlength: "10",
                modelValue: _ctx.roleModel.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.roleModel.name) = $event)),
                modelModifiers: { trim: true },
                placeholder: "请输入角色名",
                disabled: !_ctx.roleModel.allowEdit,
                autocomplete: "off"
              }, null, 8 /* PROPS */, ["modelValue", "disabled"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "角色类型",
            prop: "accountType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.roleModel.accountType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.roleModel.accountType) = $event)),
                placeholder: "请选择",
                disabled: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountTypes, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "描述",
            prop: "description"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                maxlength: "50",
                disabled: !_ctx.roleModel.allowEdit,
                modelValue: _ctx.roleModel.description,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.roleModel.description) = $event)),
                placeholder: "请输入描述",
                autocomplete: "off"
              }, null, 8 /* PROPS */, ["disabled", "modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "权限",
            prop: "accessRightCodes"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_checkbox_group, {
                  disabled: !_ctx.roleModel.allowEdit,
                  modelValue: _ctx.roleModel.accessRightCodes,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.roleModel.accessRightCodes) = $event)),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessRightList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: item.accessRightId,
                        label: item.accessRightCode
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.description), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled", "modelValue"])
              ])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                type: "primary",
                onClick: _ctx.save,
                disabled: !_ctx.roleModel.allowEdit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick", "disabled"])), [
                [_directive_has, void 0, "UpdateRole"]
              ]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.goBack
              }, {
                default: _withCtx(() => [
                  _createTextVNode("返回上一级")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model", "rules"])
    ])
  ]))
}